<template>
	<FlowTreeTriggerSection :triggerType="triggerType" :title="title" v-on="$listeners" />
</template>

<script>
import WorkflowToolService from '@/utils/workflow-tool-service';
import FlowTreeTriggerSection from './FlowTreeTriggerSection.vue';
import { NodeTypes } from '@/components/FlowTree/flow-tree-service.const';
export default {
	name: 'ToolTriggerSection',
	props: { workflow: { type: Object } },
	components: { FlowTreeTriggerSection },
	computed: {
		title() {
			return WorkflowToolService.getToolWorkflowFullTitle(this.workflow);
		},
	},
	data() {
		return { triggerType: NodeTypes.ToolTrigger };
	},
};
</script>

<style lang="scss" scoped></style>
